import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAlert from '../../hooks/useAlert';
import { onClickEvent } from '../../lib/gaAnalytics';
import { useAuth } from '../../contexts/auth';
import { CreateTicket, GetDispoDetials, handleImpressionsTrack, uploadFiles } from '../../api';
import { useAppState } from '../../contexts/appState';
import { handleLoginPopup, handleSetTicketsData } from '../../reducersAndActions/actions/appStateActions';
import {
  checkEngChars,
  CheckingValidComment,
  clickTracker,
  getCommentErrorMsg,
  getProjectId,
  hasJdMartVertical,
} from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import '../../styles/ticketCreate.css';
import SubComplaintType from './SubComplaintType';
import style from './TicketCreate.module.scss';

const issueTagging = {
  'Activation-Deactivation': 'CONTRACT RELATED',
  'Edit-my-Business': 'DATA CHANGES/VALIDATION REQUEST',
  Leads: 'LEADS',
  Payments: 'PAYMENTS & REFUNDS',
  ECS: 'ECS',
  'Contract-Information': 'CONTRACT RELATED',
  'Website-App-Related': 'OTHER ISSUES',
  'Banner-JDRR': 'BANNER RELATED',
  'JD-Pay': 'JD PAY',
  ecs: 'ECS',
  jd_pay: 'JD PAY',
  activation_deactivation: 'CONTRACT RELATED',
  edit_my_business: 'DATA CHANGES/VALIDATION REQUEST',
  payments: 'PAYMENTS & REFUNDS',
  website_app_related: 'OTHER ISSUES',
  contract_information: 'CONTRACT RELATED',
  leads: 'LEADS',
  banner_jdrr: 'BANNER RELATED',
  'Mobile Banner': 'MOBILE BANNER RELATED',
  'Web Banner': 'WEB BANNER RELATED',
  'JDRR Certificate': 'BANNER RELATED',
};
export default function TicketCreate() {
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const queryParams = new URLSearchParams(window.location.search);
  const [authState] = useAuth();
  const parentId = queryParams.get('parentId') || authState.selectedBusiness.parentid;
  const [, appDispatch] = useAppState();
  const { allBusinesses } = authState;

  const navigate = useNavigate();
  const exitPopupFlag = queryParams.get('exitPopupFlag');
  const projectId = getProjectId();
  const [fileData, setFileData] = useState([]);
  const [setAlert] = useAlert();
  const [loading, setLoading] = useState(false);
  const [issueComment, setIssueComment] = useState('');
  const [dispositionData, setDispositionData] = useState([]);
  const [haveSubmitted, setHaveSubmitted] = useState(false);
  // const createTicketFlag = queryParams.get('createTicket') || '';
  const raiseTicketTrackerID = queryParams?.get('raiseTicketTrackerID');
  const token = queryParams.get('token') || '';
  const onboardingRedirectUrl = queryParams.get('redirectUrl') || '';
  const [selectedIssueSubIssue, setSelectedIssueSubIssue] = useState({
    selectedIssue: issueTagging[queryParams?.get('key')] ? issueTagging[queryParams?.get('key')] : '',
    selectedSubIssue: '',
  });
  const [issueSubIssueData, setIssueSubIssueData] = useState({
    issueData: selectedIssueSubIssue?.selectedIssue ? [selectedIssueSubIssue.selectedIssue] : ['Select Complaint'],
    subIssueData: ['Select Complaint Type'],
  });
  const [selectedBusinessObj, setSelectedBusinessObj] = useState({});
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [issuesDisplayObj, setIssuesDisplayObj] = useState({});
  const [bannerTicketCreateFlag, setBannerTicketCreateFlag] = useState(false);
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [subComplaintsData, setSubComplaintsData] = useState([]);
  const [selectedNotModifyTypeArr, setSelectedNotModifyTypeArr] = useState([]);
  const [showSubComplaintType, setShowSubComplaintType] = useState(false);
  const [enableSubComplaintBtn, setEnableSubComplaintBtn] = useState(false);
  const [modifyDataObj, setModifyDataObj] = useState({});
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [focusedItemIndex, setFocusedItemIndex] = useState(null);
  const wrapperRefs = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRefs.current.every((ref) => ref && !ref.contains(event.target))) {
        setOpenDropdownIndex(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getSubIssueData = (dispoData) => {
    if (dispoData && dispoData.length > 0 && issueTagging[queryParams?.get('key')]) {
      const subIssueRes = dispoData.filter((each) => {
        if (each.issue_type === issueTagging[queryParams?.get('key')]) {
          return each;
        }
        return null;
      });

      const subIssueDataRes =
        subIssueRes &&
        subIssueRes[0] &&
        Object.keys(subIssueRes[0]).length > 0 &&
        subIssueRes[0]?.disp_obj &&
        Object.keys(subIssueRes[0]?.disp_obj).length > 0
          ? subIssueRes[0]?.disp_obj
          : {};
      return subIssueDataRes;
    }
    return [];
  };

  const handleResetFormFields = () => {
    const subIssueData = getSubIssueData(dispositionData);
    setSelectedIssueSubIssue({
      selectedIssue: issueTagging[queryParams?.get('key')] ? issueTagging[queryParams?.get('key')] : '',
      selectedSubIssue: '',
    });
    const updtSubIssueData = Object.keys(subIssueData).map((eachKey) => eachKey.trim());
    setIssueSubIssueData({
      ...issueSubIssueData,
      subIssueData: ['Select Complaint Type', ...updtSubIssueData] || [],
    });
    setIssueComment('');
  };

  useEffect(() => {
    const handleSetBusinessObj = async () => {
      if (projectId === 'csportal') {
        if (allBusinesses?.length > 0 && parentId) {
          let businessFound = false;
          allBusinesses.forEach((business) => {
            if (business?.parentid === parentId) {
              businessFound = true;
              setSelectedBusinessObj(business || {});
            }
          });

          if (!businessFound) {
            handleLoginPopup(appDispatch, {
              open: true,
              desc: "It looks like you've logged in with different mobile number, please login with your required registered mobile number.",
              login: false,
            });
          }
        }
      }
    };
    handleSetBusinessObj();
  }, [selectedBusiness?.docid, allBusinesses]);

  useEffect(() => {
    const handleGetIssueSubIssues = async () => {
      const dispoParams = {
        category: 'cs',
        vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'listing',
        ticketCreator: 'business',
      };

      try {
        const res = await GetDispoDetials(dispoParams, 1, projectId);
        setDispositionData(res || []);
        const dispoData = res || [];
        const issueDataRes = dispoData && dispoData.length > 0 ? res.map((each) => each.issue_type) : [];
        const subIssueData = getSubIssueData(dispoData);
        const updtSubIssueData = Object.keys(subIssueData).map((eachKey) => eachKey.trim());
        const upd = Object.fromEntries(Object.entries(subIssueData).map(([key, val]) => [key.trim(), val]));
        setIssuesDisplayObj(upd || {});
        setIssueSubIssueData({
          ...issueSubIssueData,
          issueData: ['Select Complaint', ...issueDataRes],
          subIssueData: ['Select Complaint Type', ...updtSubIssueData] || [],
        });
      } catch (err) {
        console.log('Error: ', err);
      }
    };
    handleGetIssueSubIssues();
  }, []);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const sizeInKB = (file.size / 1024).toFixed(2);
    onClickEvent(`CS-Create Ticket Page`, 'Attachment Uploaded', `Attachment Uploaded ${(file && file?.type) || ''}`);
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      const tempFileData = [...fileData];
      try {
        setLoading(true);
        const response = await uploadFiles(files, true);
        if (response.error_code === 0) {
          if (response.image_urls && response.image_urls.length > 0) {
            tempFileData.push({ name: files[0].name, url: response.image_urls[0], size: `${sizeInKB} Kb` });
            setFileData(tempFileData);
          }
        } else {
          setAlert({
            message: 'Invalid file format',
            status: false,
          });
        }
        setLoading(false);
      } catch (err) {
        console.log('Error: ', err);
      }
    } else {
      setAlert({
        message: 'Accepts only image file',
        status: false,
      });
    }
  };

  const getSourceParamVal = (isRetentionVertical) => {
    let sourceVal = '';
    if (projectId === 'genio' && token) {
      sourceVal = 'onboardingmodule_genioticket';
    } else if (raiseTicketTrackerID === 'landing') {
      sourceVal = 'getacallback_landing';
    } else {
      sourceVal =
        exitPopupFlag === '1'
          ? isRetentionVertical
            ? `exit pop up_raise a ticket button_${projectId}`
            : `exit pop up_submitbutton_${projectId}`
          : `raise a ticket_submitbutton_${projectId}`;
    }
    return sourceVal;
  };

  const selectedSubComplaintTypeArr = Object.keys(modifyDataObj)?.length;
  const getUpdatedData = () => {
    let finalIssueComment = '';
    let finalDocArr = [];
    let initialDocArr = [];

    const document = [];
    fileData.forEach((item) => {
      document.push({
        nm: item.name,
        url: item.url,
      });
    });

    let subComplaintComment = '';
    if (modifyDataObj && selectedSubComplaintTypeArr > 0) {
      Object.keys(modifyDataObj)?.forEach((key) => {
        const { selectedOption, comment, attachments } = modifyDataObj[key];
        subComplaintComment += `\n${key}:`;
        if (selectedOption) {
          subComplaintComment += `\n Customization: ${selectedOption || ''}`;
        }
        if (comment) {
          subComplaintComment += `\n Description: ${comment || ''}\n`;
        } else {
          subComplaintComment += `\n`;
        }

        if (attachments && attachments?.length > 0) {
          attachments?.forEach((item) => {
            initialDocArr.push({
              nm: item.name,
              url: item.url,
            });
          });
        }
      });
    }

    if (
      modifyDataObj &&
      selectedSubComplaintTypeArr > 0 &&
      (!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0)
    ) {
      finalIssueComment = subComplaintComment;
      initialDocArr = [...initialDocArr];
    } else if (modifyDataObj && selectedSubComplaintTypeArr > 0 && selectedNotModifyTypeArr?.length > 0) {
      finalIssueComment = subComplaintComment;
      finalIssueComment += `\n${selectedNotModifyTypeArr?.join(', ')}:\n Description: ${issueComment || ''}`;
      if (document && document?.length > 0) {
        const updtArray = document.map((item) => ({
          nm: `${selectedNotModifyTypeArr?.join(', ')}: ${item.nm}`,
          url: item.url,
        }));
        initialDocArr = [...initialDocArr, ...updtArray];
      }
    } else if ((!modifyDataObj || selectedSubComplaintTypeArr === 0) && selectedNotModifyTypeArr?.length > 0) {
      finalIssueComment += `\n${selectedNotModifyTypeArr?.join(', ')}:\n Description: ${issueComment || ''}`;
      if (document && document?.length > 0) {
        const updtArray = document.map((item) => ({
          nm: `${selectedNotModifyTypeArr?.join(', ')}: ${item.nm}`,
          url: item.url,
        }));
        initialDocArr = [...updtArray];
      }
    } else {
      finalIssueComment = issueComment;
      initialDocArr = [...document];
    }

    finalDocArr = [...initialDocArr];
    return { finalIssueComment, finalDocArr };
  };

  const handleSubmit = async (e) => {
    setHaveSubmitted(true);
    onClickEvent(`CS-Create Ticket Page`, 'Ticket Submit', 'Ticket Submit');
    e.preventDefault();

    try {
      if (projectId === 'csportal' || (projectId === 'genio' && selectedBusinessGenio?.mobile)) {
        const isRetentionVertical =
          selectedIssueSubIssue?.selectedIssue && ['ECS', 'ecs'].includes(selectedIssueSubIssue?.selectedIssue);

        const updatedDataObj = getUpdatedData();

        const updtVertical = hasJdMartVertical()
          ? 'JD MART CORPORATE'
          : isRetentionVertical
            ? 'Retention'
            : bannerTicketCreateFlag
              ? 'Design Banner'
              : 'LISTING';

        // if (showSubComplaintType) {
        //   updtVertical = 'Design Banner';
        // }
        const paramsObj = {
          vertical: updtVertical,
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm:
            projectId === 'csportal'
              ? selectedBusinessObj?.compname
              : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
          issue_type: selectedIssueSubIssue?.selectedIssue || '',
          issue_sub_type:
            (selectedIssueSubIssue?.selectedSubIssue && issuesDisplayObj?.[selectedIssueSubIssue?.selectedSubIssue]) ||
            '',
          issue_comment: updatedDataObj?.finalIssueComment || '',
          document: updatedDataObj?.finalDocArr || [],
          oid: '',
          orderid: '',
          city:
            projectId === 'csportal'
              ? selectedBusinessObj?.data_city
              : projectId === 'genio'
                ? selectedBusinessGenio?.city
                : '',
          docid:
            projectId === 'csportal'
              ? selectedBusinessObj?.docid
              : projectId === 'genio'
                ? selectedBusinessGenio?.docId
                : '',
          src: projectId === 'csportal' ? 'business' : 'sales-genio',
          src_typ:
            projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
          src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
          src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          projectId: projectId === 'csportal' ? 1 : '',
          parentId:
            projectId === 'csportal' ? selectedBusinessObj?.parentid || '' : selectedBusinessGenio?.parentId || '',
          compnm:
            projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusinessObj?.compname || '',
          bannerTicketCreateFlag,
          bannerCta: queryParams?.get('bannerCta') || '',
          source: getSourceParamVal(isRetentionVertical),
        };
        if (projectId === 'genio' && selectedIssueSubIssue?.selectedIssue === 'WEBSITE RELATED (JD OMNI)') {
          paramsObj.jdOmniFlag = 1;
          paramsObj.empCode = profile?.empCode || '';
          paramsObj.empCity = profile?.city || '';
        }

        const res = await CreateTicket(paramsObj);
        if (res.errorCode === 0) {
          handleSetTicketsData(appDispatch, {
            ticketsData: res?.data || [],
          });
          setAlert({
            message: res?.result?.msg || 'Success!',
            status: true,
          });
        } else {
          setAlert({
            message:
              (res?.message && typeof res?.message === 'string' && res?.message) ||
              (res?.result && res?.result?.msg) ||
              'Something Went Wrong!',
            status: false,
          });
        }
        if (projectId === 'genio' && token) {
          setTimeout(() => {
            if (onboardingRedirectUrl) {
              navigate(-1);
            } else {
              navigate('/genio', { replace: true });
            }
          }, 2000);
        } else {
          navigate(-1);
        }
      } else if (projectId === 'genio') {
        setAlert({
          message: 'No Mobile number found in the contract. Validate with Database team.',
          status: false,
        });
      }
    } catch (err) {
      console.log('Error: ', err);
    }
    setFileData([]);
    handleResetFormFields();
    if (queryParams?.get('vertical') === 'leadDashBoard') {
      await clickTracker('CS-TicketCreate', 'leadDashBoard');
    } else if (queryParams?.get('raiseTicketTrackerID')) {
      await clickTracker(
        `${queryParams?.get('raiseTicketTrackerID')}_ticket_submit`,
        `${queryParams?.get('raiseTicketTrackerID')}_ticket`,
      );
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = 'ticketcreation_submission';
      const faqTypeVal = '';
      const othersData = [];
      const llTrdValue = raiseTicketTrackerID === 'gr' ? 'grievance' : raiseTicketTrackerID;
      const llTrd = raiseTicketTrackerID === 'landing' ? 'get_callback' : `issue_${llTrdValue}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    setHaveSubmitted(false);
  };

  const formFields = {
    textFields: {
      // parentId: {
      // id: 'parentId',
      // value: selectedBusiness.parentid || '',
      // label: 'Enter Parent Id',
      // },
      // companyName: {
      // id: 'companyName',
      // value: selectedBusiness?.compname || '',
      // label: 'Company Name',
      // },
      // city: {
      // id: 'city',
      // value: selectedBusiness.data_city || '',
      // label: 'City',
      // },
      // department: {
      // id: 'department',
      // value: 'CS-Regular',
      // label: 'Select Department',
      // }
    },
    dropDowns: {
      issue: {
        id: 'issue',
        label: 'Complaint',
        value: selectedIssueSubIssue.selectedIssue || 'Select Complaint',
        data: issueSubIssueData.issueData,
        isDisabled:
          issueSubIssueData?.subIssueData?.length > 1 &&
          selectedIssueSubIssue?.selectedIssue === issueTagging[queryParams?.get('key')] &&
          [
            'ECS',
            'ecs',
            'Banner-JDRR',
            'Mobile Banner',
            'Web Banner',
            'JDRR Certificate',
            'leads',
            'edit_my_business',
            'Contract-Information',
          ].includes(queryParams?.get('key')),
        required: true,
      },
      subIssue: {
        id: 'subIssue',
        label: 'Complaint Type',
        value: selectedIssueSubIssue.selectedSubIssue || 'Select Complaint Type',
        data: issueSubIssueData.subIssueData,
        isDisabled: issueSubIssueData.subIssueData.length < 1,
        required: true,
      },
    },
    descriptionField: {
      description: {
        id: 'description',
        value: issueComment,
        label: 'Description',
        required: true,
      },
    },
  };

  const handleSelectedIssue = (value) => {
    const subIssueRes = dispositionData.filter((each) => {
      if (each.issue_type === value) {
        return each;
      }
      return null;
    });
    const subIssueDataRes =
      subIssueRes &&
      subIssueRes[0] &&
      Object.keys(subIssueRes[0]).length > 0 &&
      subIssueRes[0]?.disp_obj &&
      Object.keys(subIssueRes[0]?.disp_obj).length > 0
        ? subIssueRes[0]?.disp_obj
        : {};
    const upd = Object.fromEntries(Object.entries(subIssueDataRes).map(([key, val]) => [key.trim(), val]));
    setIssuesDisplayObj(upd || {});
    setIssueSubIssueData({
      ...issueSubIssueData,
      subIssueData: ['Select Complaint Type', ...Object.keys(upd)],
    });
  };

  const handleIssueSelect = async (val, id) => {
    onClickEvent(`CS-Create Ticket Page-${id} Name`, val, val);
    if (id === 'issue') {
      setShowSubComplaintType(false);
      setModifyDataObj({});
      setSelectedNotModifyTypeArr([]);
      setIssueComment('');
      setFileData([]);
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedIssue: val, selectedSubIssue: '' });
      handleSelectedIssue(val);
    } else if (id === 'subIssue') {
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedSubIssue: val.trim() });
      setBannerTicketCreateFlag(
        selectedIssueSubIssue?.selectedIssue === 'MOBILE BANNER RELATED' &&
          ['DISPLAY ISSUES', 'DESIGN RELATED', 'LINK WITH WEBSITE'].includes(issuesDisplayObj?.[val.trim()]),
      );
      setIssueComment('');
      setFileData([]);
      if (
        ['WEB BANNER RELATED', 'MOBILE BANNER RELATED'].includes(selectedIssueSubIssue?.selectedIssue) &&
        issuesDisplayObj?.[val.trim()] === 'DESIGN RELATED'
      ) {
        const params = {
          category: 'cs',
          vertical: 'DESIGN BANNER',
          ticketCreator: 'business',
        };
        const res = await GetDispoDetials(params, 1, projectId);
        const issueItem =
          res && res?.length > 0 ? res?.find((issue) => issue.issue_type === 'MOBILE BANNER RELATED') : [];

        const issueSubTypes = issueItem ? issueItem?.issue_sub_type : [];
        setSubComplaintsData(issueSubTypes || []);
        setShowSubComplaintType(true);
      } else {
        setShowSubComplaintType(false);
        setModifyDataObj({});
        setSelectedNotModifyTypeArr([]);
      }
    }
  };

  const deleteImage = (index) => {
    const tempFileData = [...fileData];
    tempFileData.splice(index, 1);
    setFileData(tempFileData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const defaultEnableSubmitBtn =
    selectedIssueSubIssue.selectedIssue !== '' &&
    selectedIssueSubIssue.selectedIssue !== 'Select Complaint' &&
    selectedIssueSubIssue.selectedSubIssue !== '' &&
    selectedIssueSubIssue.selectedSubIssue !== 'Select Complaint Type' &&
    CheckingValidComment(issueComment) &&
    // (bannerTicketCreateFlag ? fileData && fileData.length > 0 : true) &&
    !loading &&
    !haveSubmitted &&
    checkEngChars(issueComment);

  let enableSubmitButton;

  if ((!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0) && !showSubComplaintType) {
    enableSubmitButton = defaultEnableSubmitBtn;
  } else if (
    modifyDataObj &&
    selectedSubComplaintTypeArr > 0 &&
    (!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0)
  ) {
    enableSubmitButton = enableSubComplaintBtn;
  } else if (modifyDataObj && selectedSubComplaintTypeArr > 0 && selectedNotModifyTypeArr?.length > 0) {
    enableSubmitButton = enableSubComplaintBtn && defaultEnableSubmitBtn;
  } else if ((!modifyDataObj || selectedSubComplaintTypeArr === 0) && selectedNotModifyTypeArr?.length > 0) {
    enableSubmitButton = defaultEnableSubmitBtn;
  }

  const handleKeyDown = (e, dropDownData) => {
    const listLength = dropDownData?.data?.length || 0;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedItemIndex((prev) => Math.min(prev + 1, listLength - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedItemIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter' && focusedItemIndex !== -1) {
      const selectedItem = dropDownData.data[focusedItemIndex];
      handleIssueSelect(selectedItem, dropDownData.id);
      setOpenDropdownIndex(null);
      setFocusedItemIndex(-1);
    }
  };

  return (
    <>
      {(projectId === 'csportal' && selectedBusinessObj?.docid) || projectId === 'genio' ? (
        <section className="cspage cslanding">
          <div className="newticket_wpr p-20 pb-80">
            {Object.keys(formFields).map((formKey) =>
              ['textFields', 'descriptionField'].includes(formKey) && !showSubComplaintType
                ? Object.keys(formFields[formKey]).map((keyValue, idx) => (
                    <div className="group mt-20" key={idx}>
                      {formKey === 'descriptionField' ? (
                        <>
                          <label htmlFor={formFields[formKey][keyValue].id} className="description-label font14">
                            {`${formFields[formKey][keyValue].label}${
                              formFields?.[formKey][keyValue]?.required ? '*' : ''
                            } `}
                          </label>
                          <textarea
                            style={{ width: '100%' }}
                            value={formFields[formKey][keyValue].value}
                            className="csexpndwp_textarea font12 fw400 color111"
                            rows="4"
                            cols="50"
                            placeholder="Please describe your issue and our team will get back within 24-48 hours"
                            onChange={(e) => {
                              if (formFields[formKey][keyValue].id === 'description') {
                                setIssueComment(e.target.value);
                              }
                            }}
                          />
                        </>
                      ) : (
                        <input
                          id={formFields[formKey][keyValue].id}
                          className={`inputMaterial font14 color1a1 ${
                            formFields[formKey][keyValue].id === 'city' ? 'capitalize' : ''
                          }`}
                          type="text"
                          required=""
                          autoComplete="off"
                          value={formFields[formKey][keyValue].value}
                          onChange={(e) => e}
                        />
                      )}

                      <span className="bar" />
                      {formFields[formKey][keyValue].id !== 'description' && (
                        <label htmlFor={formFields[formKey][keyValue].id} className="label-wrap font14">
                          {formFields[formKey][keyValue].label}
                        </label>
                      )}

                      {formFields[formKey][keyValue].id === 'description' &&
                        !CheckingValidComment(issueComment) &&
                        issueComment &&
                        issueComment.length > 3 && (
                          <span className="colorEC4 font12">{getCommentErrorMsg(issueComment)}</span>
                        )}
                    </div>
                  ))
                : Object.entries(formFields[formKey]).map(([dropDownKey, dropDownData], index) => {
                    const isOpen = openDropdownIndex === index;
                    const showIssueField =
                      (dropDownKey === 'issue' && queryParams?.get('key') !== 'ECS') || dropDownKey === 'subIssue';
                    if (!showIssueField) return null;
                    return (
                      <div
                        ref={(el) => {
                          wrapperRefs.current[index] = el;
                        }}
                        key={index}
                        className={`${style.FormGroupBox} form_group_box mt-20`}
                      >
                        <div className="form_group">
                          <input
                            disabled={dropDownData.isDisabled}
                            className={`${style.Input} input font13 fw500 ${dropDownData.isDisabled ? 'color777' : 'color111'} pl-15 pr-45`}
                            style={{ cursor: dropDownData.isDisabled ? 'not-allowed' : 'pointer' }}
                            type="text"
                            required
                            defaultValue="Select Status"
                            value={dropDownData.value}
                            readOnly
                            onClick={() => {
                              setOpenDropdownIndex((prev) => (prev === index ? null : index));
                              setFocusedItemIndex(-1);
                            }}
                            onKeyDown={(e) => handleKeyDown(e, dropDownData)}
                            tabIndex={0}
                          />
                          <span
                            role="presentation"
                            onClick={() => {
                              if (!dropDownData?.isDisabled) {
                                setOpenDropdownIndex((prev) => (prev === index ? null : index));
                                setFocusedItemIndex(-1);
                              }
                            }}
                            style={{
                              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: '0.3s all',
                              cursor: 'pointer',
                            }}
                            className={`${style.SelectArrow} select_arrow input_icon icon`}
                          />
                          <span className="inputbar" />
                          <div
                            style={{ top: '-10px', left: '6px' }}
                            className={`${style.InputLabel} input_label font12 fw500 color777`}
                          >
                            {dropDownData.label}
                            <span className="colorEB5">*</span>
                          </div>
                          {isOpen && (
                            <div className={`${style.InputDropdown} input__dropdown`}>
                              <ul className={`${style.InputDroplist} input__droplist`} style={{ maxHeight: '260px' }}>
                                {dropDownData.data?.map((each, idx) => {
                                  const isFocused = idx === focusedItemIndex;
                                  return (
                                    <li
                                      key={idx}
                                      role="presentation"
                                      className={`${style.InputDropdownItem} input__dropitem font14 fw500`}
                                      style={{ backgroundColor: isFocused ? '#f0f0f0' : 'transparent' }}
                                      onClick={() => {
                                        handleIssueSelect(each, dropDownData.id);
                                        setOpenDropdownIndex(null);
                                        setFocusedItemIndex(-1);
                                      }}
                                      onMouseDown={(e) => {
                                        e.stopPropagation();
                                        handleIssueSelect(each, dropDownData.id);
                                        setOpenDropdownIndex(null);
                                        setFocusedItemIndex(-1);
                                      }}
                                      onMouseEnter={() => setFocusedItemIndex(idx)}
                                      onMouseLeave={() => setFocusedItemIndex(-1)}
                                    >
                                      {each}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }),
            )}
            {!showSubComplaintType ? (
              <div className="group phy_mandate_list uploadphoto mt-20 mb-15 mb-0">
                <p className="uploadtxt font14 pb-20">Upload Attachments</p>
                {fileData && fileData.length > 0
                  ? fileData.map((each, idx) => (
                      <span key={idx} className="uploaded_img mr-10 mb-10">
                        <img key={idx} alt={each.name} src={each.url} />
                        <span className="uploaded_img_text font11 colorFFF">
                          <div
                            onClick={() => deleteImage(idx)}
                            onKeyDown={() => {}}
                            className="ml-5"
                            key={idx}
                            role="button"
                            tabIndex="0"
                            aria-label="Delete image"
                            style={{ display: 'inline-block' }}
                          >
                            <img
                              alt="delete_img"
                              src="https://images.jdmagicbox.com/standard/cs_module/baf79d55c4951b13b60ebbb1c5f9e773.jpg"
                            />
                          </div>
                        </span>
                        <span className="uploaded_overlay" />
                      </span>
                    ))
                  : loading && (
                      <span className="uploaded_img">
                        <div
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
                        >
                          <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                        </div>
                      </span>
                    )}
                {(!bannerTicketCreateFlag ||
                  (bannerTicketCreateFlag && fileData && fileData.length < 1 && !loading)) && (
                  <span className="uploaded_img">
                    <span className="upload_type_wpr color393 font11">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileUpload}
                        onClick={(e) => {
                          e.target.value = null;
                        }}
                        name=""
                      />
                      <img alt="addPhoto" src="https://akam.cdn.jdmagicbox.com/images/icons/genio/gno_addphoto.svg" />
                    </span>
                  </span>
                )}
              </div>
            ) : (
              <SubComplaintType
                subComplaintsData={subComplaintsData}
                issueComment={issueComment}
                setIssueComment={setIssueComment}
                fileData={fileData}
                deleteImage={deleteImage}
                handleFileUpload={handleFileUpload}
                selectedNotModifyTypeArr={selectedNotModifyTypeArr}
                setSelectedNotModifyTypeArr={setSelectedNotModifyTypeArr}
                setEnableSubComplaintBtn={setEnableSubComplaintBtn}
                modifyDataObj={modifyDataObj}
                setModifyDataObj={setModifyDataObj}
              />
            )}
            <div className="mandatebtns fullwidthbtn">
              <button
                className={`${!enableSubmitButton ? 'mandatebtns_disabled' : 'mandatebtns_enable'} `}
                disabled={!enableSubmitButton}
                type="button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}
